module.exports = __webpack_public_path__ + "img/p12-desc.df6159d0.png";